/* eslint-disable func-names */
/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable max-classes-per-file */

import { merge, first, flattenDeep, last } from 'lodash-es';
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import {
  Mix,
  PropertyDefaultValue,
  dayjs,
  findTsByString,
  findFirstTsByString,
  filterOriginalTs,
} from '../../common';
import { i18nMixin, loaderMixin, getQueryObject } from '../../decorators';
import { getRouteOptionsAndParams, getConfig } from '../ki-app';
import nls from '../../locales/index';
import '../ki-ts-viewer/ki-ts-viewer';
import '../ki-ts-viewer/ki-ts-list-select';
import KIWIS from '../../api/kiwis';
import { AppConfigDefinition } from '../../defs/AppConfigDefinition';
import { sanitizeFilename } from '../ki-wwp-graph/GraphHelper';

let KiWISInst;
const graphRange = {
  min: dayjs().subtract(dayjs.duration('P1Y')).valueOf(),
  max: dayjs().valueOf(),
};

@customElement('wwp-station-ts-viewer')
export default class WwpStationTsViewer extends Mix(
  LitElement,
  PropertyDefaultValue,
  loaderMixin,
  [i18nMixin, { nls }],
) {
  static styles = css``;
  // kiwis = new KIWIS({ basePath: 'http://localhost:3003/services/KiWIS/KiWIS', datasource: 1 });

  @property({ type: String })
  stationNo?: string;

  @property({ type: String })
  stationId?: string;

  @property({ type: String })
  parameterNo?: string;

  @property({ type: String })
  parameterName?: string;

  @property({ type: String })
  groupBy: string = 'stationparameter_no';

  @property({ type: Array })
  mainTs?: string[];

  @property({ type: Array })
  presetTs?: string[];

  @property({ type: Array })
  alarmTs: string[] = [];

  @property({ type: Array })
  periods: string[][] = [
    ['last1month', 'last6month', 'last1year', 'last5year', 'last10year'],
  ];

  @property({ type: Array })
  selectedTs: string[] = [];

  @state()
  private tsList: any[] = [];

  @state()
  private mainTsObj: any = {};

  @state()
  private thresholdTsList: any[] = [];

  @state()
  private presetTsList: any[] = [];

  @state()
  private title: string = '';

  @state()
  private stationLabel?: string;

  @state()
  private tsFilter?: any[];

  @state()
  private dynMenu: any;

  @state()
  private filterOriginal?: boolean;

  config: AppConfigDefinition = getConfig();

  async onAfterEnter(location: any) {
    const params = getRouteOptionsAndParams(location, [
      'layerName',
      'stationId',
      'stationLabel',
      'remarkAttr',
    ]);
    console.debug(params);
    this.title = params.options?.title || '';
    this.parameterName = params.options?.parameter;
    this.parameterNo = params.options?.parameterNo;
    this.groupBy = params.options?.groupBy;
    this.dynMenu = params.options?.dynMenu;
    this.mainTs = params.options?.mainTs;
    this.periods = params.options?.periods;
    this.alarmTs = params.options?.alarmTs;
    this.tsFilter = params.options?.tsFilter;
    this.presetTs = params.options?.presetTs;
    this.stationLabel = params.options?.stationLabel;
    this.alarmTs = params.options?.alarmTs || [];
    this.stationId = params.stationId;

    if (params?.options?.defaultPeriod) {
      graphRange.min = dayjs()
        .subtract(
          dayjs.duration(params.options.defaultPeriod || 'P1Y').asMinutes(),
          'minute',
        )
        .valueOf();
    }
  }

  async firstUpdated() {
    super.firstUpdated();
    KiWISInst = new KIWIS({ ...this.dynMenu.kiwis });
    await this.fetchTsList();
  }

  async fetchTsList() {
    const queryparams = {
      metadata: true,
      station_id: this.stationId,
    };
    queryparams[this.groupBy] = this.parameterNo;
    let list = await KiWISInst.getTimeseriesList(queryparams, [
      'ts_id',
      'ts_name',
      'ts_shortname',
      'coverage',
      'ts_path',
      'ca_ts',
      'stationparameter_name',
      'stationparameter_longname',
      'stationparameter_no',
      'ts_unitsymbol',
    ]);

    // Remove empty ts and filter by provided definition
    list = list.filter(ts => ts.to !== '');
    if (this.tsFilter) {
      list = flattenDeep(
        this.tsFilter?.map(pattern => {
          const res = findTsByString(pattern, list);
          // Filter all timeseries which are original timeseries (ending with .O)
          if (this.filterOriginal) return filterOriginalTs(res);
          return res;
        }),
      );
    }
    // Resolve timeseries objects from patterns
    this._resolveTsFromPatterns(list);

    // Further checks
    list.map(item => {
      // Detect alarmTs

      item.isBinary = item.ts_shortname.includes('.Binary.');

      if (
        this.thresholdTsList &&
        Array.isArray(this.thresholdTsList) &&
        this.thresholdTsList
          .flatMap(t => t.ts_shortname)
          .includes(item.ts_shortname)
      )
        item.isThreshold = true;
      // Mark as preselected to keep ts-selector in sync with chart
      if (
        this.presetTsList
          .flatMap(p => p.ts_shortname)
          ?.includes(item.ts_shortname)
      )
        item.preselected = true;
    });
    this.tsList = list;
    this.requestUpdate();
  }

  // Convert provided patterns to available timeseries
  _resolveTsFromPatterns(l = this.tsList) {
    // Find TS
    this.mainTsObj =
      first(flattenDeep(this.mainTs?.map(ts => findTsByString(ts, l)))) ||
      first(l) ||
      {};
    this.thresholdTsList = flattenDeep(
      this.alarmTs?.map(ts => findTsByString(ts, l)),
    );
    this.presetTsList = flattenDeep(
      this.presetTs?.map(ts => findTsByString(ts, l)),
    );
    console.debug(
      'Filter Resolving Results (Main/Alarm/Preset): ',
      this.mainTsObj,
      this.thresholdTsList,
      this.presetTsList,
    );
  }

  render() {
    // language=html
    return this.tsList?.length
      ? html`
          <ki-ts-viewer
            .getTsData="${this.getTsData}"
            .chartOptions="${this.chartOptions}"
            .range="${graphRange}"
            .customAttributes="${this.mainTsObj}"
            .tsList="${this.tsList}"
            .periods="${this.periods}"
          >
            <div slot="title">${this.title}</div>
            <div slot="actions">
              <ki-ts-list-select
                id="ts-selctor"
                .tsList="${this.tsList}"
                .presetTs="${this.presetTsList}"
                .mainTs="${this.mainTsObj?.ts_path}"
                @change="${this.updateTs}"
              ></ki-ts-list-select>
            </div>
          </ki-ts-viewer>
        `
      : // TODO: Loading spinner
        html`Loading...`;
  }

  get _tsSelect(): any {
    return getQueryObject(this, '#ts-selctor');
  }

  // eslint-disable-next-line class-methods-use-this
  get chartOptions(): any {
    return merge(
      {
        chart: {
          zoomType: 'x',
        },
        boost: {
          useGPUTranslations: true,
          seriesThreshold: 5,
        },
        credits: {
          enabled: false,
        },

        exporting: {
          chartOptions: {
            title: {
              text: `${this.parameterName}`,
            },
            subtitle: {
              text: `${this.stationNo}-${this.parameterName}`,
            },
          },
          filename: sanitizeFilename(
            `${this.stationLabel}-${this.parameterName}`,
          ),
          fallbackToExportServer:
            this.config?.allowHighchartsExportServer ?? false,
          sourceWidth: 1600,
          sourceHeight: 800,
          scale: 1,
          buttons: {
            contextButton: {
              enabled: false,
            },
          },
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
            },
            states: {
              inactive: {
                enabled: false,
              },
            },
            label: {
              style: {
                color: '#333333',
                fontWeight: 'bold',
              },
              format: '<span style="color: {color}">■</span> {name}',
            },
          },
        },
        series: this.selectedTs?.map(ts => {
          const tsObj = findFirstTsByString(ts, this.tsList);
          return {
            label: {
              enabled: tsObj.isThreshold ?? false,
              style: {
                color: '#333333',
                fontWeight: 'bold',
              },
              format: '<span style="color: {color}">■</span> {name}',
            },
            ts,
            id: ts,
            mainTs: ts === this.mainTsObj.ts_path,
            name: tsObj.ts_name || ts,
            color: this.config.tsColors?.[tsObj.ts_shortname],
            step: tsObj.isThreshold ? 'left' : undefined,
            dashStyle: tsObj.isThreshold ? 'Dash' : 'Solid',
          };
        }),
        title: {
          text: '',
        },
        yAxis: {
          title: {
            // Hide Y-Axis-label if no information is available
            text: this.mainTsObj
              ? `${
                  this.mainTsObj.stationparameter_longname ||
                  this.mainTsObj.stationparameter_name
                } [${this.mainTsObj.ts_unitsymbol}]`
              : '',
          },
        },
      },
      {},
    );
  }

  async getTsData({ range, ts }: { range: any; ts: string }) {
    // Keep selected timeframe
    const tsObj = findFirstTsByString(ts, this.tsList);

    graphRange.min = range.min;
    graphRange.max = range.max;

    const { ts_path } = tsObj;
    let data;
    // Get whole dataset if ts is Alarm
    // or just selected timeframe if timeseries is regular
    if (tsObj.isThreshold) {
      data = await KiWISInst.getTimeseriesValues(
        {
          ts_path,
          period: 'complete',
        },
        null,
        'json',
      );
      // Add pivot point for displaying alarmTs
      this._transformAlarmTs(data);
    } else if (tsObj.isBinary) {
      data = await KiWISInst.getTimeseriesValues(
        {
          metadata: true,
          md_returnfields: 'ts_id,ensembledate,ensembledispatchinfo',
          ts_path,
        },
        null,
        'json',
      );
      if (data[0]?.ensembledate) {
        const ensTs = new Date(data[0]?.ensembledate).getTime();
        if (ensTs > graphRange.max) {
          graphRange.max = ensTs + 7 * 24 * 60 * 60 * 1000;
        }
      }
    } else {
      data = await KiWISInst.getTimeseriesValues(
        {
          ts_path: `${ts_path};compress(2000)`,
          from: range.min,
          to: range.max,
        },
        null,
        'json',
      );
    }
    this.dispatchEvent(
      new CustomEvent('changedate', {
        bubbles: true,
        detail: {
          fromTime: range.min,
          toTime: range.max,
        },
      }),
    );
    return data[0].data;
  }

  _transformAlarmTs(data: any) {
    // Add left-side limit
    data[0].data.unshift([
      new Date('1950-1-1').toISOString(),
      data[0].data[0][1],
    ]);
    // Add right-side limit
    data[0].data.push([
      new Date(Date.now()).toISOString(),
      last(data[0].data)[1],
    ]);
  }

  updateTs(evt: CustomEvent) {
    this.selectedTs = [...evt.detail.value];
  }
}
